var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBackForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconBackForward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 65 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0858 11.0001L13.1464 7.06074C12.9512 6.86547 12.9512 6.54889 13.1464 6.35363L13.8535 5.64652C14.0488 5.45126 14.3654 5.45126 14.5606 5.64652L20.5606 11.6465C20.7559 11.8418 20.7559 12.1584 20.5606 12.3536L14.5606 18.3536C14.3654 18.5489 14.0488 18.5489 13.8535 18.3536L13.1464 17.6465C12.9512 17.4513 12.9512 17.1347 13.1464 16.9394L17.0858 13.0001L3.99999 13.0001C3.72384 13.0001 3.49999 12.7762 3.49998 12.5001L3.49998 11.5001C3.49999 11.2239 3.72384 11.0001 3.99999 11.0001L17.0858 11.0001Z",
    fill: "#71869D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackForward);
export default __webpack_public_path__ + "static/media/iconBackForward.f5bb9e9d7828e4b72573c7030be5436f.svg";
export { ForwardRef as ReactComponent };